<template>
  <v-ons-page id="tutorial-page">
    <v-ons-toolbar>
      <div class="center">IIDX HS Calc 2</div>
    </v-ons-toolbar>
    <v-ons-card>
      <div class="title">このWebアプリは開発中です</div>
      <div class="content">
        <p>今後、機能が変更、追加される可能性があります。</p>
        <p>
          不具合を発見された方はこちらまで<br>
          <a target="_blank" href="https://hyrorre.com/contact/">Contact | HY Techs</a>
        </p>
      </div>
    </v-ons-card>
    <v-ons-card>
      <div class="title">推奨環境</div>
      <div class="content">
        <p>iOS : Safari (iOS11.3以上)<br>Android/PC/Mac :  Google Chrome (最新版)</p>
        <p>ホーム画面に追加してからの利用を推奨<br>(オフラインでも動作が可能になります)</p>
        <p></p>
        <p>iOSの場合、OSの仕様上、ホーム画面に戻るたびに画面がリセットされます</p>
      </div>
    </v-ons-card>
  </v-ons-page>
</template>

<script>
  export default {
    name: 'calc-page',
    data () {
      return {
      }
    },
    methods: {
    },
    mounted: function () {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TutorialPage.vue